<template>
  <pre
    class="px-6 py-4 text-sm rounded-lg temp border border-gray-300 bg-gray-200 break-words"
    ref="codeBlock"
  ></pre>
</template>

<style scoped>
pre {
  white-space: pre-wrap;
}
</style>

<script setup>
import { ref, onMounted, toRaw, watchEffect } from 'vue'
import 'highlight.js/styles/github.css'
import { highlightWorker } from '@/utils/syntax/init'

const props = defineProps({
  id: {
    type: Number
  },
  json: {
    type: Object,
    default: () => {}
  }
})

const PANEL_ANIMATION_DURATION = 150

const codeBlock = ref(null)
let mountedAt = null

onMounted(() => (mountedAt = Date.now()))

watchEffect(() => {
  if (props.json && typeof props.json === 'object') {
    highlightWorker.postMessage({
      id: props.id,
      json: toRaw(props.json)
    })
  }
})

highlightWorker.onmessage = function (event) {
  if (event.data.id !== props.id) {
    return
  }

  const elapsedSinceMount = Date.now() - mountedAt
  const renderDelay = Math.max(0, PANEL_ANIMATION_DURATION - elapsedSinceMount)

  const codeContainer = document.createElement('code')
  codeContainer.innerHTML = event.data.code

  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      codeBlock.value.replaceChildren(codeContainer)
    })
  }, renderDelay)
}
</script>
